import { FC } from 'react';
import { css } from '@emotion/react';
import { useCallIntelFeatureAccess } from '@frontend/call-intel-core';
import { useScopedAppFlagStore } from '@frontend/scope';
import { theme } from '@frontend/theme';

interface NotificationSettingsWrapperProps {
  children: React.ReactNode;
}

export const NotificationSettingsWrapper: FC<NotificationSettingsWrapperProps> = ({ children }) => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();

  const { hasCallIntelFeature: isCallIntelEnabled } = useCallIntelFeatureAccess();
  const isAiNotificationsAllowed = getFeatureFlagValue('task-center-ai-notification-setting');

  const shouldShowSettings = isCallIntelEnabled && isAiNotificationsAllowed;

  if (shouldShowSettings) {
    return <div css={styles.container}>{children}</div>;
  }

  return null;
};

const styles = {
  container: css`
    border-top: 1px solid ${theme.colors.neutral20};
    padding: ${theme.spacing(2, 0, 0, 2)};
    margin-top: ${theme.spacing(1.5)};
  `,
};
